var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProductSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010\\u805A\\u878D\\u6613\\u3011\\u5339\\u914D\\u4EA7\\u54C1\\uFF081\\u4E2A\\uFF09_\\u91D1\\u8272",
    transform: "translate(-306.000000, -393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(15.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13",
    transform: "translate(13.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(278.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#AC4F02",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-19",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7 12.9913535 11.998003 17.9893565 19.998003 9.98935652"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductSelected);
export default __webpack_public_path__ + "static/media/icon-product-selected.e780021939e5a3f8943149117137df6e.svg";
export { ForwardRef as ReactComponent };